import { StatusPage } from '@app/shared/components/status-pages/StatusPage';
import styles from './under-maintenance.module.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { selectMaintenanceModeSettings } from '@app/core/store/ui-values-slice-selectors';
import { useLocale } from '@app/core/hooks/useLocale';
import { dateFormatter } from '@app/shared/formatters';

const PARENT_CLASSNAME = 'under-maintenance-page';

const UnderMaintenancePage: React.FC = (): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();
  const { l } = useLocale();
  const maintenanceModeSettings = useAppSelector(selectMaintenanceModeSettings);

  useEffect(() => {
    if (!maintenanceModeSettings.active) {
      window.location.href = '/';
    }
  }, [maintenanceModeSettings.active, location.pathname, navigate]);

  const formattedEndTime = maintenanceModeSettings.end
    ? dateFormatter(maintenanceModeSettings.end, {
        timeStyle: 'short',
      })
    : l('_NotAvailable');

  return (
    <div className={styles[`${PARENT_CLASSNAME}`]}>
      <StatusPage>
        <p className="message">
          {l('_MaintenancePageMessage', {
            releaseVersion: maintenanceModeSettings.version,
            formattedEndTime: formattedEndTime,
          })}
        </p>
        <br />
        <p>{l('_MaintenanceMessage')}</p>
        {maintenanceModeSettings.message && (
          <>
            <br />
            <p>{maintenanceModeSettings.message}</p>
          </>
        )}
      </StatusPage>
    </div>
  );
};

export default UnderMaintenancePage;
